export default [
  {
    name: "payments-planned",
    path: "/payments/planned",
    component: () =>
      import(
        /*webpackChunkName: "payments" */ "@/pages/payments-planned/Index"
      ),
    meta: {
      title: "titles.payments_planned"
    }
  }
];
